export default {
  message: {
    title: '',
    preferVisitRead: '',
    preferVisitListten: '',
    preferVisitComplete: 'Completa',
    preferVisitShort: 'Curta',
    preferVisitSignoguia: 'Signoguia',
    titleVisitType: 'Visites guiades',
    titleMenu: 'Menú',
    moreInfo:'Saber-ne més?',
    moreInfoNo: 'No',
    moreInfoYes:'Sí',
    downloadAudio: '(Descàrrega d\'àudios)',
    download: 'Descàrrega dels arxius',
    downloadVideo: '(Descàrrega de videos)',
    downloadSignoguia: 'Descàrrega dels arxius de video',
    errorDownload: 'Hi ha hagut un error en la descàrrega. Torna a intentar-ho',
    cancelDownload: 'Has cancel·lat la descàrrega.',
    retry: 'Reintentar',
    noConnection: 'No tens conexió a internet',
    titleMap: 'VISITA À TORRE',
    map: 'mapa_eng.png',

    initDownload: 'Aguarde enquanto os áudios são descarregados',
    endDownload: 'Os áudios foram descarregados. Desfrute da visita!',



     menuItems: [
        {
            img: '1.jpg',
            imageMenu: '',
            title: 'VISITA À TORRE',
            author: '',
            description: '',
            audio: '1.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '2.jpg',
            imageMenu: '',
            title: 'VISITA À TORRE',
            author: '',
            description: '',
            audio: '2.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '3.jpg',
            imageMenu: '',
            title: 'VISITA À TORRE',
            author: '',
            description: '',
            audio: '3.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '4.jpg',
            imageMenu: '',
            title: 'VISITA À TORRE',
            author: '',
            description: '',
            audio: '4.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '5.jpg',
            imageMenu: '',
            title: 'VISITA À TORRE',
            author: '',
            description: '',
            audio: '5.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '6a.jpg',
            imageMenu: '',
            title: 'VISITA À TORRE',
            author: '',
            description: '',
            audio: '6.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '6a.jpg',
                    second: '0'
                },
                {
                    img: '6b.jpg',
                    second: '145'
                },
                {
                    img: '6c.jpg',
                    second: '224'
                },
                {
                    img: '6d.jpg',
                    second: '303'
                },
                {
                    img: '6e.jpg',
                    second: '403'
                },
            ],
        },
        {
            img: 'thumb_2.png',
            imageMenu: '7.jpg',
            title: 'Créditos',
            author: '',
            description: 'Trama Media para la Catedral de Segovia.<br><br>Imágenes: Catedral de Segovia.<br><br>Música: Antonio de Cabezón (Naxos 8.554.836).<br><br>Trama Media ha hecho todo lo posible por obtener las autorizaciones necesarias para todos los contenidos reproducidos en esta guía. No obstante, si desea formular alguna reclamación relativa a la propiedad intelectual, no dude en ponerse en contacto con nosotros.<br><br>Todos los derechos reservados.<br><br>',
            audio: '',
            visitType: '{all}',
            moreInfoItem: '',
            isCredits: true,

        }
    ]
  },
}



// WEBPACK FOOTER //
// ./src/data/i18n/portugues.js